import { getContenidoTipoZoom } from './contenido-tipo-zoom';
import getContenidoTipoEjercicio from './contenido-tipo-ejercicio';
import getContenidoTipoSwf from './contenido-tipo-swf';
import { getContenidoTipoPng } from './contenido-tipo-png';
import { getContenidoTipoFuncionAbrirEjercicio } from './contenido-tipo-funcion-abrir-ejercicio';
import { getContenidoTipoFuncionAbrirIframe } from './contenido-tipo-funcion-abrir-iframe';
import { getContenidoTipoFuncionAbrirEjercicioGG } from './contenido-tipo-funcion-abrir-ejercicio-gg';
import { getContenidoTipoFuncionAbrirVisorFC } from './contenido-tipo-funcion-abrir-visor-fc'; // import getContenidoTipoFuncion from './__contenido-tipo-funcion'

var tipoVinculo = function tipoVinculo(zona) {
  return zona.vinculo && zona.vinculo.split(',')[0] || 'zoom';
};

export var getContenido = function getContenido(state, zona) {
  var tipo = tipoVinculo(zona);

  switch (tipo) {
    case 'zoom':
      return getContenidoTipoZoom(state, zona);

    case 'ejercicio':
      return getContenidoTipoEjercicio(state, zona);

    case 'swf':
      return getContenidoTipoSwf(state, zona);

    case 'png':
      return getContenidoTipoPng(state, zona);

    case 'funcion':
      switch (zona.vinculo.split(':')[0]) {
        case 'funcion,abrirEjercicio':
          return getContenidoTipoFuncionAbrirEjercicio(state, zona);

        case 'funcion,abrirIframe':
          return getContenidoTipoFuncionAbrirIframe(state, zona);

        case 'funcion,abrirEjercicioGG':
          return getContenidoTipoFuncionAbrirEjercicioGG(state, zona);

        case 'funcion,abrirVisorFC':
          return getContenidoTipoFuncionAbrirVisorFC(state, zona);

        default:
          window.console.error("pantalla-ventana/selectors/zona getContenido funcion desconocida (" + zona.vinculo.split(':')[0] + ")");
          return;
      }

    default:
      window.console.error("pantalla-ventana/selectors/zona getContenido desconocido (" + zona.vinculo + ")");
  }
};
export var getContenidoBoton = function getContenidoBoton(state, boton) {
  return getContenido(state, boton); // const tipo = tipoVinculo(boton)
  // switch (tipo) {
  //     case 'zoom':
  //         return getContenidoTipoZoomBoton(state, boton)
  //     case 'swf':
  //         return getContenidoTipoSwf(state, boton)
  //     case 'png':
  //         return getContenidoTipoPng(state, zona)
  //     default:
  //     window.console.error("pantalla-ventana/selectors/zona getContenidoBoton desconocido ("+ boton.vinculo +")")
  // }
};
export var getConsolaAudio = function getConsolaAudio(state, zona) {
  // TODO: traer aqui las configuraciones por defecto correspondientes
  return zona.audio || null;
};
export var getConsolaLupa = function getConsolaLupa(state, zona) {
  // TODO: traer aqui las configuraciones por defecto correspondientes    
  return zona.lupa;
};
export var getBotones = function getBotones(state, zona) {
  // TODO: traer aqui las configuraciones por defecto correspondientes
  var BOTON = zona.BOTON || [];
  return Array.isArray(BOTON) ? BOTON : [BOTON];
};
var AJUSTE_AUTO = 'auto';
var AJUSTE_ANCHO = 'ancho';
var AJUSTE_ESCALA = 'escala';
var AJUSTE_ALTO = 'alto';
export var getAjuste = function getAjuste(state, consolaLupa) {
  var _consolaLupa$split = consolaLupa.split(','),
      ajuste = _consolaLupa$split[1]; // const ajuste = consolaLupa.split(',')[1] || AJUSTE_AUTO


  switch (ajuste) {
    case AJUSTE_ANCHO:
      return AJUSTE_ANCHO;

    case AJUSTE_ESCALA:
      return AJUSTE_AUTO;

    case AJUSTE_ALTO:
      return AJUSTE_ALTO;

    default:
      return AJUSTE_AUTO;
  }
};
export var getEscala = function getEscala(state, consolaLupa) {
  var _consolaLupa$split2 = consolaLupa.split(','),
      escala = _consolaLupa$split2[2];

  if (isNaN(escala)) {
    return 100;
  }

  var valorEscala = Number(escala);

  if (valorEscala < 0) {
    return 0;
  }
  /*if (valorEscala > 100) {
      return 100
  }*/


  return escala;
};